// Pour l'accessibilité, on veut que le lecteur d'écran prenne la bonne prononciation pour les

import { IUnite } from '../../lib/interface/unite'

// unités qui ne sont pas en langue française
export const getLanguePourLesUnitesPasEnFrancais = (noeud: INoeudDimension) => {
  if (noeud.identifiantDimension === '91' && noeud.identifiantNoeudDimension === '60022') {
    return { lang: 'de' }
  } else if (noeud.identifiantDimension === '91' && noeud.identifiantNoeudDimension === '60024') {
    return { lang: 'en' }
  }
  return {}
}
export const getLanguePourLesUnitesPasEnFrancaisBlocPhoto = (unite: IUnite) => {
  if (unite.code === 'HIE3008043') {
    return { lang: 'de' }
  } else if (unite.code === 'HIE2004034') {
    return { lang: 'en' }
  }
  return {}
}
